<template>
  <b-modal :id="modalId"
           title="Add User"
           @hide="clearData">
    <errors-alert :errors="errors"></errors-alert>
    <form @submit.prevent="">
      <div class="container-fluid">
        <div class="row form-group">
          <label class="col-2 col-form-label text-muted" for="name">Name:</label>
          <div class="col-8">
            <input class="form-control" :class="{'is-invalid': isNameInvalid}"
                   type="text"
                   v-model.trim="newUser.name" id="name"/>
            <div v-show="isNameInvalid" class="invalid-feedback">
              Name cannot be empty.
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-2 col-form-label text-muted" for="email">Email:</label>
          <div class="col-8">
            <input class="form-control" :class="{'is-invalid': isEmailInvalid}" type="email"
                   v-model.trim="newUser.email" id="email"/>
            <div v-show="isEmailInvalid" class="invalid-feedback">
              Email cannot be empty.
            </div>
          </div>
        </div>
      </div>
      <!-- dummy button for allowing press ENTER in the form -->
      <button hidden
              @click="promiseCreateUser = handleCreateUser()">
        Save Changes
      </button>
    </form>

    <template slot="modal-footer">
      <button class="btn btn-secondary" @click="hideModal">Close</button>
      <button class="mr-0 btn btn-success"
              @click="promiseCreateUser = handleCreateUser()"
              v-busy-button="promiseCreateUser">
        Add User
      </button>
    </template>
  </b-modal>
</template>

<script>
  import userService from '@/services/amio-api/user.service'
  import authService from '@/services/security/hosted-auth.service'
  import ErrorsAlert from '../common/ErrorsAlert.vue'

  export default {
    components: {
      'errors-alert': ErrorsAlert
    },

    props: {
      modalId: {
        type: String,
        required: true
      }
    },

    store: {
      user: 'administration.userEdit.user'
    },

    data() {
      const {connectionName, webappUrl} = authService._getAuth0Props()
      return {
        newUser: {
          name: '',
          email: '',
          connectionName,
          webappUrl
        },
        promiseCreateUser: null,
        isNameInvalid: false,
        isEmailInvalid: false,
        errors: []
      }
    },

    methods: {
      hideModal() {
        this.clearData()
        this.$root.$emit('bv::hide::modal', this.modalId)
      },

      clearData() {
        this.errors = []
        this.isEmailInvalid = false
        this.isNameInvalid = false
        this.newUser.name = ''
        this.newUser.email = ''
        this.clearPromise()
      },

      clearPromise() {
        this.promiseCreateUser = null
      },

      validateUser() {
        this.isNameInvalid = !this.newUser.name
        this.isEmailInvalid = !this.newUser.email
        return !(this.isEmailInvalid || this.isNameInvalid)
      },

      handleCreateUser() {
        if (!this.validateUser()) return

        return userService.create(this.newUser, [422])
          .then((newUser) => {
            this.user = newUser
            this.$router.push({name: 'administration.settings.users.edit', params: {id: newUser.id}})
            this.$emit('userCreated', newUser)
          })
          .then(this.hideModal)
          .catch(error => {
            if (error.response.status !== 422) return

            log.debug('user cannot be added', error)
            this.errors = error.response.data.errors
          })
          .then(this.clearPromise)
      }
    }
  }
</script>
